import axios from "axios";

export const Baseurl = () => {
	var baseurl1 = "";
	if (process.env.REACT_APP_HOST === "local") {
		baseurl1 = "http://localhost:3001/api/";
	} else {
		baseurl1 = window.location.origin + "/api/";
	}
	return baseurl1;
};

export const getDataAPI = async (url, token) => {
	const res = await axios.get(Baseurl() + `${url}`, {
		headers: { Authorization: token },
	});
	return res;
};

export const getDataPDF = async (url, post, token) => {
	try {
		const csrfToken = await CsrfToken();

		const res = await axios.post(Baseurl() + `${url}`, post, {
			responseType: "blob",
			headers: { Authorization: token, "X-CSRF-Token": csrfToken },
			withCredentials: true,
		});

		return res;
	} catch (err) {
		console.error("Pdf request failed", err);
		throw err;
	}
};

// Get CSRF token from the backend

export const CsrfToken = async () => {
	try {
		const res = await axios.get(Baseurl() + "csrf-token", {
			withCredentials: true,
		});
		console.log("res.data.csrfToken", res.data.csrfToken);
		return res.data.csrfToken;
	} catch (err) {
		console.error("CSRF token fetch failed", err);
		throw err;
	}
};

export const postDataAPI = async (url, post, token) => {
	try {
		const csrfToken = await CsrfToken();

		const res = await axios.post(Baseurl() + url, post, {
			headers: {
				Authorization: token,
				"X-CSRF-Token": csrfToken,
			},
			withCredentials: true,
		});
		return res;
	} catch (err) {
		console.error("Post request failed", err);
		throw err;
	}
};

export const putDataAPI = async (url, post, token) => {
	const csrfToken = await CsrfToken();
	const res = await axios.put(Baseurl() + `${url}`, post, {
		headers: {
			Authorization: token,
			"X-CSRF-Token": csrfToken,
		},
		withCredentials: true,
	});
	return res;
};

export const patchDataAPI = async (url, post, token) => {
	const csrfToken = await CsrfToken();
	const res = await axios.patch(Baseurl() + `${url}`, post, {
		headers: {
			Authorization: token,
			"X-CSRF-Token": csrfToken,
		},
		withCredentials: true,
	});
	return res;
};

export const deleteDataAPI = async (url, token) => {
	const csrfToken = await CsrfToken();
	const res = await axios.delete(Baseurl() + `${url}`, {
		headers: {
			Authorization: token,
			"X-CSRF-Token": csrfToken,
		},
		withCredentials: true,
	});
	return res;
};
